/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Module for Layout of the app

Author: Deimos Space UK

Version: 1.0
*/

import React, { Suspense, useState } from "react";
import LeftSidebar from "../sidebar/LeftSidebar";
import { AiOutlineMenu } from "react-icons/ai";
import TopBar from "../topbar/TopBar";
import { Container } from "reactstrap";
function Layout({ children }) {
	const [toggled, setToggled] = useState(false);
	const [collapsed, setCollapsed] = useState(null);
	const handleToggleSidebar = (value) => {
		setToggled(value);
		setCollapsed(!value);
	};
	return (
		<>
			<div className={`app  ${toggled ? "toggled" : ""}`}>
				<Suspense>
					<LeftSidebar
						toggled={toggled}
						collapsed={collapsed}
						handleToggleSidebar={handleToggleSidebar}
					/>
				</Suspense>
				<div className="content-page" style={{overflow:'scroll'}}>
					<div >
						<Suspense>
							<TopBar >
								<div
									className="btn-toggle"
									onClick={() => handleToggleSidebar(true)}
								>
									<AiOutlineMenu />
								</div>
							</TopBar>
						</Suspense>
						<Container fluid>
							<Suspense>{children}</Suspense>
						</Container>
					</div>
				</div>
			</div>
		</>
	);
}

export default Layout;
